import { render, staticRenderFns } from "./MotionAnalysisYoutube.vue?vue&type=template&id=af9591be&scoped=true&"
import script from "./MotionAnalysisYoutube.vue?vue&type=script&lang=js&"
export * from "./MotionAnalysisYoutube.vue?vue&type=script&lang=js&"
import style0 from "./MotionAnalysisYoutube.vue?vue&type=style&index=0&id=af9591be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9591be",
  null
  
)

export default component.exports